import { Instagram, Youtube, Mail, ExternalLink } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-charcoal text-warmwhite relative overflow-hidden" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24">
        <p className="text-xs uppercase tracking-widest-custom text-warmwhite/50 mb-8">Manifesto</p>
        <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl font-light leading-[1.05] tracking-tight max-w-5xl">
          Your dream deserves more than an idea — <span className="italic text-gold">it deserves execution.</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mt-24 pt-12 border-t border-warmwhite/15">
          <div className="md:col-span-2">
            <div className="flex items-baseline gap-2 mb-4">
              <span className="font-serif text-3xl">James</span>
              <span className="font-serif italic text-gold text-2xl">1:1</span>
            </div>
            <p className="text-warmwhite/70 text-sm leading-relaxed max-w-md">
              Music artist, audio engineer, photographer, and creative director. Building brands and projects that outlast the moment.
            </p>
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-widest-custom text-warmwhite/50 mb-4">Navigate</p>
            <ul className="space-y-3 text-sm">
              <li><a href="#about" className="hover:text-gold transition-colors">About</a></li>
              <li><a href="#services" className="hover:text-gold transition-colors">Services</a></li>
              <li><a href="#work" className="hover:text-gold transition-colors">Work</a></li>
              <li><a href="#music" className="hover:text-gold transition-colors">Music</a></li>
            </ul>
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-widest-custom text-warmwhite/50 mb-4">Connect</p>
            <ul className="space-y-3 text-sm">
              <li><a href="mailto:hello@jamesone.co" className="inline-flex items-center gap-2 hover:text-gold transition-colors" data-testid="footer-email"><Mail className="w-4 h-4" /> hello@jamesone.co</a></li>
              <li><a href="https://itsjamesone.cruisebrothers.com/cb/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-gold transition-colors" data-testid="footer-travel"><ExternalLink className="w-4 h-4" /> Travel with James</a></li>
              <li><a href="#" className="inline-flex items-center gap-2 hover:text-gold transition-colors"><Instagram className="w-4 h-4" /> Instagram</a></li>
              <li><a href="#" className="inline-flex items-center gap-2 hover:text-gold transition-colors"><Youtube className="w-4 h-4" /> YouTube</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-warmwhite/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-warmwhite/40">
          <p>© {new Date().getFullYear()} James Douglas. All rights reserved.</p>
          <p className="uppercase tracking-widest-custom">Faith · Creativity · Excellence</p>
        </div>
      </div>
    </footer>
  );
}
